import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { TRANSACTIONS, USERS, WAREHOUSES, BOXES, DEVICES } from 'api';
import useFetch from 'utils/fetch/useFetch';
import Filter from '../../components/Filter/index';
import Table from './components/List';
import Modal from './components/AddTransaction';
import Range from './components/Range';
import { ReactComponent as Plus } from '../../images/plus.svg';

function Transaction() {
  const [visible, setVisible] = useState(false);
  const [pushItems, setPushItems] = useState(null);
  const total = useSelector((state) =>
    get(state, `fetch.transactions.total`, 0),
  );
  const limit = useSelector((state) =>
    get(state, `fetch.transactions.limit`, 0),
  );
  const { t } = useTranslation();
  const { data, postData, loading, getData, deleteData, loadMore } = useFetch(
    TRANSACTIONS,
    {
      uniqId: 'transactions',
      autoFetch: true,
      initialOptions: { offset: 0 },
    },
  );

  const {
    data: users,
    updateData: updateUsers,
    getData: getUsers,
    deleteData: deleteUsers,
  } = useFetch(USERS, {
    uniqId: 'users',
    autoFetch: true,
  });

  const {
    data: clients,
    updateData: updateClients,
    getData: getClients,
    deleteData: deleteClients,
  } = useFetch(USERS, {
    uniqId: 'clients',
    autoFetch: false,
  });

  const { data: storages } = useFetch(WAREHOUSES, {
    uniqId: 'storages',
    autoFetch: true,
  });

  const {
    data: boxes,
    getData: getBoxes,
    loading: loadingBox,
    updateData: updateBox,
    postData: postBox,
  } = useFetch(BOXES, {
    uniqId: 'boxes',
    autoFetch: false,
  });

  const {
    data: locks,
    getData: getDevices,
    updateData: updateDevice,
    loading: loadingDevice,
  } = useFetch(DEVICES, {
    uniqId: 'device',
    autoFetch: false,
  });

  const loadMoreItems = () => {
    loadMore(20);
  };

  useEffect(() => {
    if (data && !pushItems) setPushItems(data.length + 5);
  }, [data]);



  useEffect(() => {
    getClients({
      role: 'client',
      authorized: 1,
    });
  }, []);

  return (
    <div>
      <div className="flex mb-26 items-center justify-end text-graytext">
        {' '}
        <Button
          onClick={() => {
            setVisible(!visible);
          }}
          className="flex mr-17 justify-center pl-1 p-0 items-center border-none bg-primary rounded-full w-18 h-18 hover:bg-primary focus:bg-primary"
        >
          <Plus className="p-0 m-0" />
        </Button>{' '}
        <div
          onClick={() => {
            setVisible(!visible);
          }}
          className="flex cursor-pointer items-center h-1"
        >
          {t('addTransaction')}
        </div>
      </div>
      <Row align="middle" justify="space-between">
        <Col span={17}>
          <Filter
            dataSource={data}
            updateData={getData}
            uniqId="transactions"
            placeholder={t('placeholderQuickTransaction')}
          />
        </Col>
        <Col className="text-graytext" span={1}>
          {t('range')}
        </Col>
        <Col span={5}>
          <Row gutter={[16, 0]}>
            <Range getData={getData} />
          </Row>
        </Col>
      </Row>
      <Table
        boxes={boxes}
        updateBox={updateBox}
        getBoxes={getBoxes}
        users={users}
        deleteData={deleteData}
        loading={loading}
        data={data}
        getData={getData}
        locks={locks}
        getDevices={getDevices}
        updateDevice={updateDevice}
        loadingDevice={loadingDevice}
        postBox={postBox}
        updateUsers={updateUsers}
        getUsers={getUsers}
        loadingBox={loadingBox}
        deleteUsers={deleteUsers}
        limit={limit}
      />
      {data ? (
        total !== data.length ? (
          <div className="flex w-full mt-20 mb-20 justify-center items-center">
            <Button
              type="primary"
              onClick={() => {
                loadMoreItems();
              }}
            >
              {t('loadMore')}
            </Button>
          </div>
        ) : null
      ) : null}
      <Modal
        postTransaction={postData}
        loadingBox={loadingBox}
        boxes={boxes}
        getBoxes={getBoxes}
        storages={storages}
        users={clients}
        visible={visible}
        setVisible={setVisible}
      />
    </div>
  );
}

Transaction.propTypes = {};

export default Transaction;
